import React from 'react';

import { Icon as ChakraIcon } from '@chakra-ui/react';

import { IconProps } from '../../icon/types';

export const FacebookCircleIcon = (props: IconProps) => (
  <ChakraIcon
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="currentColor"
    {...props}
  >
    <path
      d="M20 10C20 4.47716 15.5228 -1.90735e-06 10 -1.90735e-06C4.47716 -1.90735e-06 0 4.47716 0 10C0 14.6898 3.2286 18.6249 7.58424 19.7055V13.0558H5.52216V10H7.58424V8.68324C7.58424 5.27956 9.12456 3.70196 12.4662 3.70196C13.0997 3.70196 14.1928 3.82616 14.64 3.9504V6.72056C14.404 6.69572 13.9941 6.68328 13.4848 6.68328C11.845 6.68328 11.2115 7.3044 11.2115 8.91928V10H14.4778L13.9167 13.0558H11.2115V19.9268C16.1629 19.3287 20 15.1127 20 10Z"
      fill="currentColor"
    />
  </ChakraIcon>
);
